import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { MAIN_MENU_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, MAIN_MENU_TRANSLATION_KEY, {
  SEE_ALL: 'See all',
  // LeftMenu
  LEFT_MENU_TITLE: 'Menu',
  OPEN_MENU: 'Open menu',
  CATALOG_MENU_LABEL: 'Courses',
  RESOURCES_MENU_LABEL: 'Resources',
  DEGREES_MENU_LABEL: 'Degrees',
  PREMIUM_LANDING_LINK_LABEL: 'For Individuals',
  B2B_PLANS_LANDING_LINK_LABEL: 'For Businesses',
  HIGHER_EDUCATION_LABEL: 'Higher Education',
  B2B_LANDING_LINK_LABEL: 'For Businesses',
  HELP_CENTER_LABEL: 'Help Center',
  // CatalogMenu
  CATALOG_MENU_TITLE: 'Explore Crehana',
  // CatalogMenu - Categories
  CATALOG_CATEGORIES_TITLE: 'Categories',
  CATALOG_SUBCATEGORIES_TITLE: 'Subcategories',
  CATALOG_SOFTWARE_TITLE: 'Software',
  COURSE_COUNT: '{{count}} course',
  COURSE_COUNT_plural: '{{count}} courses',
  // CatalogMenu - NewCourses
  NEW_COURSES_TITLE: 'New releases',
  NEW_COURSES_POPPER_TITLE: 'New releases on Crehana',
  NEW_COURSES_SEE_ALL: 'See all new courses',
  // CatalogMenu - MicroDegrees
  MICRODEGREES_POPPER_TITLE: 'Digital programs with Universities',
  FULL_MICRODEGREE_TITLE: 'MicroDegree in {{title}}',
  FULL_BOOTCAMP_TITLE: 'Bootcamp in {{title}}',
  MONTH_COUNT: '{{count}} month',
  MONTH_COUNT_plural: '{{count}} months',
  MICRODEGREE_PARTNER_LABEL: 'Co-created and certified by {{partner}}',
  MICRODEGREE_SEE_DETAILS: 'See program details',
  // CatalogMenu - Academies
  ACADEMY_TITLE: 'Academies',
  ACADEMY_POPPER_TITLE: 'Discover our academies',
  FULL_ACADEMY_TITLE: '{{title}}',
  ACADEMY_COUNT: '{{count}} path',
  ACADEMY_COUNT_plural: '{{count}} paths',
  ACADEMIES_COUNT: '{{count}} Academy',
  ACADEMIES_COUNT_plural: '{{count}} Academies',
  ACADEMY_LEARNING_PATHS_COUNT: '{{count}} learning path',
  ACADEMY_LEARNING_PATHS_COUNT_plural: '{{count}} learning paths',
  ACADEMY_TAG: 'New',
  // ResourcesMenu
  MENTOR_LANDING_LABEL: 'Mentorships',
  BLOG_LABEL: 'Blog',
  RESOURCES_TOOLS_LABEL: 'Tools',
  COURSE_AGENDA_LABEL: 'Course Agenda',
  CREHANA_LIVE_LABEL: 'Lives',
  // Search
  SEARCH_TITLE: 'Search',
  SEARCH_INPUT_HINT: 'What do you want to learn today?',
  SEARCH_CLEAR: 'Clear',
  // RightMenu
  USER_DASHBOARD_COURSES_LABEL: 'My courses',
  USER_DASHBOARD_PRODUCTS_LABEL: 'Products',
  USER_DASHBOARD_SAVED_COURSES_LABEL: 'My saved',
  B2B_DASHBOARD_LIST: 'My profiles',
  B2B_ADMIN_DASHBOARD_LABEL_SHORT: 'Admin',
  B2B_ADMIN_DASHBOARD_LABEL: 'Admin Panel',
  B2B_LEADER_DASHBOARD_LABEL_SHORT: 'Leader',
  B2B_LEADER_DASHBOARD_LABEL: 'Leader Panel',
  INBOX_LABEL: 'Chat with a mentor',
  INBOX_LABEL_FOR_MENTORS: 'Mentorship Chat',
  SHOPPING_CART_LABEL: 'Shopping Cart',
  NOTIFICATIONS_LABEL: 'Notifications',
  FEEDBACK_LABEL: 'Feedback',
  // Auth
  LOGIN_LABEL_SHORT: 'Login',
  LOGIN_LABEL: 'Sign in',
  REGISTER_LABEL: 'Register',
  // UserMenu
  USER_MENU_TITLE: 'My Account',
  LOGOUT: 'Logout',
  // DashboardMenu
  FAQS: 'FAQS',
  DASHBOARD_SEARCH_HINT: 'What are you looking for in your panel?',
  RENEWAL_ITEM_MESSAGE: 'Your membership will expire in {{remainingDays}} days!',
  RENEWAL_ITEM_CTA: 'Renew now',
  // Labels
  SEARCH_LABEL: 'Search',
  MESSAGE_LABEL: 'Message',
  // SwitchToOldHomeUser
  SWITCH_TO_OLD_HU_LABEL: 'You are using the new version of Crehana',
  SWITCH_TO_OLD_HU_CTA: 'Switch to old version',
  // Blog menu
  DOWNLOADABLE_RESOURCES_LABEL: 'Downloadables',
  BLOG_CATEGORIES_LINK_LABEL: 'Categories',
  LEFT_MENU_FOLLOW_US: 'Follow us on',
  SEARCH_PLACEHOLDER: 'Search article, ebook, video...',
  LEFT_MENU_CATEGORIES_VIEW_MORE: 'View more categories',
  LEFT_MENU_CATEGORIES_VIEW_LESS: 'View fewer categories',
  LEFT_MENU_SOLUTIONS: 'Solutions',
  SOLUTIONS_MENU_LEARNING_MANAGEMENT: 'Learning Management',
  SOLUTIONS_MENU_E_LEARNING: 'E-Learning',
  SOLUTIONS_MENU_E_LEARNING_DESCRIPTION: 'Access +1000 courses, academies, and mentorship for your team.',
  SOLUTIONS_MENU_ELEVATE_LMS: 'Elevate LMS',
  SOLUTIONS_MENU_ELEVATE_LMS_DESCRIPTION: 'Centralize your training plan, content, and applications.',
  SOLUTIONS_MENU_SKILL_XP: 'Skill XP: Skill Testing',
  SOLUTIONS_MENU_SKILL_XP_DESCRIPTION: 'Measure the current skill level of each person.',
  SOLUTIONS_MENU_TALENT_MANAGEMENT: 'Talent Management',
  SOLUTIONS_MENU_DEVELOPMENT: 'Development',
  SOLUTIONS_MENU_DEVELOPMENT_DESCRIPTION: 'Develop skills',
  SOLUTIONS_MENU_WORK_ENVIRONMENT: 'Work Environment',
  SOLUTIONS_MENU_WORK_ENVIRONMENT_DESCRIPTION: 'Measure the work environment of your company',
  SOLUTIONS_MENU_PERFORMANCE: 'Performance',
  SOLUTIONS_MENU_PERFORMANCE_DESCRIPTION: "Manage and measure your team's objectives with the business.",
  SOLUTIONS_MENU_ENGAGEMENT: 'Engagement',
  SOLUTIONS_MENU_ENGAGEMENT_DESCRIPTION: 'Manage satisfaction with NPS surveys, feedback, and more.',
  // RightMenu > Products
  PRODUCTS_TITLE: 'Crehana Products',
  PRODUCTS_RECOGNITION_TITLE: 'Recognitions',
  PRODUCTS_RECOGNITION_DESCRIPTION: 'Recognize and promote achievements with badges',
  PRODUCTS_PERFORMANCE_TITLE: 'Performance',
  PRODUCTS_PERFORMANCE_DESCRIPTION: 'Goal management and development plan',
  PRODUCTS_ENVIRONMENT_TITLE: 'Environment',
  PRODUCTS_RENVIRONMENT_DESCRIPTION: 'Work environment evaluations and surveys',
  PRODUCTS_ELEARNING_TITLE: 'E-learning',
  PRODUCTS_ELEARNING_DESCRIPTION: 'Courses and resources to elevate your skills',
  PRODUCTS_ANALYTICS_TITLE: 'Analytics',
  PRODUCTS_ANALYTICS_DESCRIPTION: 'Monitor your processes and generate reports',
  PRODUCTS_MANAGE_TITLE: 'Manage',
  PRODUCTS_MANAGE_DESCRIPTION: 'Manage users and company settings',
  PRODUCTS_TREND_FUTURE_TITLE: 'Future of People',
  PRODUCTS_TREND_FUTURE_DESCRIPTION: 'Relevant articles for professional development',
  PRODUCTS_TREND_AMAZING_TITLE: 'Amazing People',
  PRODUCTS_TREND_AMAZING_DESCRIPTION: 'Podcasts with experts in personal development'
});